import { KitType } from '@repo/types';
import { Typography } from '@repo/ui';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import useFeature from 'services/features/useFeature';
import FlaggedMetricsCount from '../../FlaggedMetricsCount';
import ConditionLinkCard from '../../NewConditionMetricsList/ConditionLinkCard';
import styles from '../ConditionsEducationalModal.module.css';

export default function MicrobiomeConnectionsSlide() {
  const { isFeatureEnabled: isGutXAxisEnabled } = useFeature('gut_x_axis');
  const { currentKitType } = useCurrentKitAndTinyAccount();

  const showGutXAxis = isGutXAxisEnabled && currentKitType === KitType.STOOL;

  if (!showGutXAxis)
    return (
      <Typography variant='heading-l' className={styles.headingText}>
        Explore the microbiome connections linked to the conditions you reported
        first and learn more about the research behind them.
      </Typography>
    );

  return (
    <>
      <Typography variant='heading-l' className={styles.headingText}>
        If you've told us you have a condition, we'll highlight it.
      </Typography>
      <ConditionLinkCard
        name={'Eczema'}
        trailing={<FlaggedMetricsCount flagged={2} total={35} />}
        className={styles.conditionLinkCard}
        markedInSurvey
      />
      <Typography
        variant='body-s'
        className={styles.headingText}
        color='warm-grey-700'
      >
        Explore the microbiome connections linked to your condition and learn
        more about the research behind them.
      </Typography>
    </>
  );
}
